import React, { useEffect, useState } from 'react';
import InputBox from '../../components/Inputs/InputBox';
import Button from '../../components/Button';
import { Form, Formik } from 'formik';
import {
  TalentScoreSchema
} from '../../schema/score.schema';
import SuccessfulEntryModal from '../../components/Modal/SuccessfulEntryModal';
import { useAddDevsSoftSkillResultMutation, useVerifySoftSkillEmailMutation } from '../../reactWrapper/Redux/apiSlice';
import { toast } from 'react-toastify';


const EnterResult = () => {
  const [showModal, setShowModal] = useState(false);
  const [addDevsSoftSkillResult, { isLoading, isSuccess }] = useAddDevsSoftSkillResultMutation()
  const [verifySoftSkillEmail, { data }] = useVerifySoftSkillEmailMutation({ fixedCacheKey: 'shared-update-post' })

  const initialTalentScore = {
    email: data?.email,
    communication: data?.cbtSoftSkill?.communication,
    motivation: data?.cbtSoftSkill?.motivation,
    consistency: data?.cbtSoftSkill?.consistency_reliability,
    leadership: data?.cbtSoftSkill?.leadership,
    creativity: data?.cbtSoftSkill?.creativity,
    productivity: data?.cbtSoftSkill?.productivity,
    depth: data?.cbtSoftSkill?.depth_of_past_work,
    velocity: data?.cbtSoftSkill?.learning_velocity,
    alignment: data?.cbtSoftSkill?.value_alignment,
    self: data?.cbtSoftSkill?.self_driven,
    interview: data?.cbtSoftSkill?.interview_link,
  };


  const handleSubmit = (values, { resetForm }) => {
    const result = new FormData()
    result.append('email', values.email);
    result.append('communication', values.communication);
    result.append('motivation', values.motivation);
    result.append('consistency_reliability', values.consistency);
    result.append('leadership', values.leadership);
    result.append('creativity', values.creativity);
    result.append('productivity', values.productivity);
    result.append('depth_of_past_work', values.depth);
    result.append('learning_velocity', values.velocity);
    result.append('value_alignment', values.alignment);
    result.append('self_driven', values.self);
    result.append('interview_link', values.interview);

    addDevsSoftSkillResult(result);
    resetForm()
  };

  useEffect(() => {
    if (isSuccess) {
      toast.success('Interview Score Added')

      setTimeout(() => {
        window.location.href = `${process.env.REACT_APP_BASE_ADMIN_URL_LIVE}/search-talent`;
      }, 3000)
    }
  })

  const handleCloseModal = () => {
    setShowModal(false);
  };

  return (
    <div className='mx-auto max-w-3xl space-y-6'>
      <SuccessfulEntryModal open={showModal} closeModal={handleCloseModal} />

      <div>
        <div className='text-[11px] font-semibold uppercase tracking-wider text-brand-orange'>
          HR Result
        </div>
        <h2 className='text-xl font-bold text-brand-navy sm:text-2xl'>
          Enter Talent Score
        </h2>
      </div>

      <div className='rounded-2xl border bg-card p-6 shadow-ui-sm'>
          <Formik
            onSubmit={handleSubmit}
            validationSchema={TalentScoreSchema}
            enableReinitialize
            initialValues={initialTalentScore}
          >
            {({
              values,
              setFieldTouched,
              isValid,
              setFieldValue,
              errors,
              handleSubmit,

              ...formik
            }) => (
              <Form>
                <div className='grid w-full grid-cols-1 gap-4 sm:grid-cols-2'>
                  <InputBox
                    type={'email'}
                    placeholder={'Email'}
                    id={'email'}
                    name={'email'}
                    value={values?.email}
                    isValid={values?.email && !errors?.email}
                    setFieldTouched={setFieldTouched}
                    handleSubmit={handleSubmit}
                  />
                  <InputBox
                    type={'text'}
                    placeholder={'Communication'}
                    id={'communication'}
                    name={'communication'}
                    value={values?.communication}
                    isValid={values?.communication && !errors?.communication}
                    setFieldTouched={setFieldTouched}
                    handleSubmit={handleSubmit}
                  />
                  <InputBox
                    type={'motivation'}
                    placeholder={'Motivation'}
                    id={'motivation'}
                    name={'motivation'}
                    value={values?.motivation}
                    isValid={values?.motivation && !errors?.motivation}
                    setFieldTouched={setFieldTouched}
                    handleSubmit={handleSubmit}
                  />
                  <InputBox
                    type={'text'}
                    placeholder={'Consistency'}
                    id={'consistency'}
                    name={'consistency'}
                    value={values?.consistency}
                    isValid={values?.consistency && !errors?.consistency}
                    setFieldTouched={setFieldTouched}
                    handleSubmit={handleSubmit}
                  />
                  <InputBox
                    type={'text'}
                    placeholder={'Leadership'}
                    id={'leadership'}
                    name={'leadership'}
                    value={values?.leadership}
                    isValid={values?.leadership && !errors?.leadership}
                    setFieldTouched={setFieldTouched}
                    handleSubmit={handleSubmit}
                  />
                  <InputBox
                    type={'text'}
                    placeholder={'Creativity'}
                    label={''}
                    className={''}
                    id={'creativity'}
                    name={'creativity'}
                    value={values?.creativity}
                    isValid={values?.creativity && !errors?.creativity}
                    setFieldTouched={setFieldTouched}
                    handleSubmit={handleSubmit}
                  />
                  <InputBox
                    type={'text'}
                    placeholder={'Productivity'}
                    id={'productivity'}
                    name={'productivity'}
                    value={values?.productivity}
                    isValid={values?.productivity && !errors?.productivity}
                    setFieldTouched={setFieldTouched}
                    handleSubmit={handleSubmit}
                  />
                  <InputBox
                    type={'text'}
                    placeholder={'Depth of past work'}
                    label={''}
                    className={''}
                    id={'depth'}
                    name={'depth'}
                    value={values?.depth}
                    isValid={values?.depth && !errors?.depth}
                    setFieldTouched={setFieldTouched}
                    handleSubmit={handleSubmit}
                  />
                  <InputBox
                    type={'text'}
                    placeholder={'Learning velocity'}
                    label={''}
                    className={''}
                    id={'velocity'}
                    name={'velocity'}
                    value={values?.velocity}
                    isValid={values?.velocity && !errors?.velocity}
                    setFieldTouched={setFieldTouched}
                    handleSubmit={handleSubmit}
                  />
                  <InputBox
                    type={'text'}
                    placeholder={'Value alignment'}
                    label={''}
                    className={''}
                    id={'alignment'}
                    name={'alignment'}
                    value={values?.alignment}
                    isValid={values?.alignment && !errors?.alignment}
                    setFieldTouched={setFieldTouched}
                    handleSubmit={handleSubmit}
                  />
                  <InputBox
                    type={'text'}
                    placeholder={'Self driven'}
                    label={''}
                    className={''}
                    id={'self'}
                    name={'self'}
                    value={values?.self}
                    isValid={values?.self && !errors?.self}
                    setFieldTouched={setFieldTouched}
                    handleSubmit={handleSubmit}
                  />
                  <InputBox
                    type={'text'}
                    placeholder={'Interview video link'}
                    label={''}
                    className={''}
                    id={'interview'}
                    name={'interview'}
                    value={values?.interview}
                    isValid={values?.interview && !errors?.interview}
                    setFieldTouched={setFieldTouched}
                    handleSubmit={handleSubmit}
                  />
                </div>
                <div className='mt-6 flex items-center justify-end border-t pt-4'>
                  <Button className={'bg-brand-orange hover:bg-brand-orange-600'} type='submit'>
                    {
                      isLoading ? 'Submitting...' : 'Add Result'
                    }
                  </Button>
                </div>
              </Form>
            )}
          </Formik>
      </div>
    </div>
  );
};

export default EnterResult;
